import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { StoreDataService } from '../../../shared/services/store-data-service/store-data.service';
import { getSchool, getSchoolLoadedStatus } from 'Src/ng2/store';
import { LoadSchool } from '../../../store/actions/school-actions';
import { UrlNavigationService } from 'Src/ng2/shared/services/url-navigation/url-navigation.service';

@Injectable()
export class SchoolResourceResolver implements Resolve<any> {
  constructor (
    private storeDataService: StoreDataService,
  ) {}

  resolve (route: ActivatedRouteSnapshot) {
    const entityId = UrlNavigationService.getEntityId(route);
    return this.storeDataService.loadDataAndGetStream$(entityId, getSchoolLoadedStatus, LoadSchool, getSchool);
  }
}
